import { Layout } from "components2";
import { ALink, BackButton2, CommonButton2, CommonButtonSecondary, InputText, NextButton2 } from "components2/CommonUI";
import { useOtpTime } from "hooks";
import { useEffect } from "react";
import { useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateOtp, updateOtpToken, updateOtpTokenExpAt } from "redux/o2Appointment";
import {
  hasAppointment,
  getOtpEmailById,
  getOtpSmsById,
  validateOtpEmailById,
  validateOtpSmsById
} from "services/api-service2";
import { isValidOTP } from "utils/common2";
import { O2APPOINTMENT_INFO, O2IDENTITY } from "../constants/route";
import ReCAPTCHA from "react-google-recaptcha";

const from = { state: { from: O2IDENTITY } };

export default function O2AppointmentWelcome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [errorOtp, setErrorOtp] = useState(null);
  const { start: startOtpTime, stop: stopOtpTime, time: otpTime } = useOtpTime();
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const [ firstOtpTaken, setFirstOtpTaken] = useState(false);
  const [captchaResponseToken, setCaptchaResponseToken] = useState(null);

  const {
    hasApptNricFin,
    hasApptPassport,
    hasApptEmail,
    hasApptMobile,
    createdUsingSingpass,
    otp,
    otpToken
  } = useSelector((state) => state.o2Appointment);

  useEffect(()=>{
    batch(()=>{
      dispatch(updateOtp(null));
      dispatch(updateOtpToken(null));
      dispatch(updateOtpTokenExpAt(null));
    }) 
  }, []);

  const onBlurOtp = () => {
    if(!otp || otp.trim().length === 0) {
      return;
    }
    if (!isValidOTP(otp)) {
      setErrorOtp("Please provide a valid OTP.");
      return;
    }
    setErrorOtp(null);
  };

  const clkGetOtp = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    // dispatch(updateOtp(null));

    if (hasApptMobile) {
      getOtpSmsById({ identity: hasApptNricFin || hasApptPassport, captchaResponseToken }).then((status) => {
        if (status === "ok") {
          startOtpTime(window.smsOtpExpSecsO2);
          dispatch(updateOtp(""));
        } else {
          // ask reCaptcha again
          setCaptchaResponseToken(null);
          setFirstOtpTaken(false);
        }
        setLoading(false);
      });
    } else if (hasApptEmail) {
      getOtpEmailById({ identity: hasApptNricFin || hasApptPassport, captchaResponseToken }).then((status) => {
        if (status === "ok") {
          startOtpTime(window.smsOtpExpSecsO2);
          dispatch(updateOtp(""));
        } else {
          // ask reCaptcha again
          setCaptchaResponseToken(null);
          setFirstOtpTaken(false);
        }
        setLoading(false);
      });
    }
  };

  const onReCaptchaChange = (v) => {
    console.log("onReCaptchaChange", v);
    setCaptchaResponseToken(v);
  }

  const onChangeOtp = (e) => {
    dispatch(updateOtp(e.target.value.trim()));
  };

  const clkBack = () => {
    navigate(O2IDENTITY);
  };

  const clkGetNewOTP = () => {
    setCaptchaResponseToken(null);
    setFirstOtpTaken(false);
  }

  const clkNext = () => {
    if (loading) {
      return;
    }
    setLoading(true);

    if (hasApptMobile) {
      validateOtpSmsById({ identity: hasApptNricFin || hasApptPassport, otp }).then(
        ({ validation, otpToken, expAt }) => {
          if (validation) {
            dispatch(updateOtpToken(otpToken));
            dispatch(updateOtpTokenExpAt(expAt));
            hasAppointment(hasApptNricFin || hasApptPassport).then((hasAppt) => {
              setLoading(false);
              if (hasAppt) {
                navigate(O2APPOINTMENT_INFO);
              }
            });
            return;
          } else {
            setLoading(false);
          }
          setErrorOtp("Please provide a valid OTP.");
        }
      );
    } else if (hasApptEmail) {
      validateOtpEmailById({ identity: hasApptNricFin || hasApptPassport, otp }).then(
        ({ validation, otpToken, expAt }) => {
          if (validation) {
            dispatch(updateOtpToken(otpToken));
            dispatch(updateOtpTokenExpAt(expAt));
            hasAppointment(hasApptNricFin || hasApptPassport).then((hasAppt) => {
              setLoading(false);
              if (hasAppt) {
                navigate(O2APPOINTMENT_INFO);
              }
            });
            return;
          } else {
            setLoading(false);
          }
          setErrorOtp("Please provide a valid OTP.");
        }
      );
    }

    // if (!isValidOTP(otp)) {
    //   setErrorOtp("Please provide a valid OTP.");
    //   return;
    // }

    // if (otp !== "123456") {
    //   setErrorOtp("The OTP is incorrect. Please try again.");
    //   return;
    // }

    // dispatch(updateOtpToken("XXX"));
    // navigate(O2APPOINTMENT_INFO);
  };

  if(createdUsingSingpass) {
    window.location.href = window.mainLoginUrl2;
    //navigate(O2APPOINTMENT_INFO);

    return (<Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">CONTACT US</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
      <div>
        <div className="form-box--plain mt-3">
          <div className={"px-1 px-3 py-3 py-md-5 text-center"}>
            Loading...
          </div>
        </div>
      </div>
    </Layout>);
  }

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">CONTACT US</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
      <div>
        <div className="form-box--plain mt-3">
          <div className={"px-1 px-3 py-3 py-md-5"}>
            <h4 className={"text-center sm-mb-32 md-mb-32 lg-mb-48 xl-mb-48 lg-fs-32 xl-fs-32"}>Welcome back</h4>
            {/* <ReCAPTCHA
              sitekey={window.reCaptchaSiteKey}
              onChange={onReCaptchaChange}
            /> */}
            {/* createdUsingSingpass = singpassNric === visitorIdentity */}
            {/* createdUsingSingpass && <>
              <div className="row justify-content-center pb-3">
                  <div className="col-12 col-md-8 col-lg-6 text-center" style={{ border: "0px solid red" }}>
                    <div>
                        Appointment found under{" "}
                        <span style={{ fontWeight: 600 }}>{hasApptNricFin || hasApptPassport}</span>
                        .
                    </div>
                  </div>
              </div>
              <div className="row justify-content-center pb-3">
                <div
                  className="col-12 col-md-8 col-lg-6 text-center"
                  style={{ border: "0px solid red" }}>
                  <ALink href="#" onClick={()=>{
                    window.location.href = window.mainLoginUrl2;
                  }}>Log in through Singpass</ALink>
                </div>
              </div>
            </>*/ }
            {!createdUsingSingpass && (
              <>
                <div className="row justify-content-center pb-3">
                  <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                    <div>
                      <div>
                        Appointment found under{" "}
                        <span style={{ fontWeight: 600 }}>{hasApptNricFin || hasApptPassport}</span>
                        . A one-time password (OTP) will be delivered to{" "}
                        {hasApptMobile ? "mobile number" : "email address"}{" "}
                        <span style={{ fontWeight: 600 }}>{hasApptMobile || hasApptEmail}</span>.
                      </div>
                    </div>
                  </div>
                </div>

                {!firstOtpTaken && !otpToken && (
                  <>
                    <div className="row justify-content-center mt-3 mb-3">
                      <div className="col-12 col-md-8 col-lg-6 text-center" style={{display:"Flex", "justifyContent":"center"}}>
                        <ReCAPTCHA
                          sitekey={window.reCaptchaSiteKey}
                          onChange={onReCaptchaChange}
                        />
                      </div>
                    </div>
                    <div className="row justify-content-center mt-3 mb-3">
                      <div className="col-12 col-md-8 col-lg-6 text-center">

                        <CommonButtonSecondary
                          text={"Get OTP"}
                          disabled={captchaResponseToken === null}
                          onClick={()=>{
                            setFirstOtpTaken(true);
                            clkGetOtp();
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {firstOtpTaken && (
                  <>
                    <div className="row justify-content-center">
                      <div className="col-12 col-md-8 col-lg-6">
                        <InputText
                          label="Enter OTP"
                          value={otp}
                          onChange={onChangeOtp}
                          isInvalid={errorOtp !== null}
                          errorMessage={errorOtp}
                          onBlur={onBlurOtp}
                        />
                      </div>
                    </div>
                    {otpTime !== null && (
                    <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24 mb-5">
                      <div className="col-12 col-md-8 col-lg-6">
                        You can get a new OTP in {otpTime}.
                      </div>
                    </div>
                    )}
                    {otpTime === null && (
                      <div className="row justify-content-center" style={{marginTop:24, marginBottom: 32}}>
                        <div className="col-12 col-md-8 col-lg-6">
                          <ALink onClick={clkGetNewOTP}>Get new OTP</ALink>
                        </div>
                      </div>)}
                  </>
                )}

                {hasApptNricFin && (
                  <div className="row justify-content-center pb-3">
                    <div
                      className="col-12 col-md-8 col-lg-6 text-center"
                      style={{ border: "0px solid red" }}>
                      <ALink href="#" onClick={()=>{
                        window.location.href = window.mainLoginUrl2;
                      }}>Alternatively, log in through Singpass</ALink>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="form-footer">
            {/*<div className={"flex--space-between"}>*/}
            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <div className={"mobile-w-100"}>
                <BackButton2 onClick={clkBack} />
              </div>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <NextButton2 disabled={otpTime == null} onClick={clkNext} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
